var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarginH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52502 12.1338L13.2809 12.1338",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8733 11.8281C17.0655 11.9866 17.0655 12.281 16.8733 12.4395L13.7311 15.0312C13.4726 15.2444 13.0826 15.0605 13.0826 14.7254L13.0826 9.54216C13.0826 9.20708 13.4726 9.02321 13.7311 9.23642L16.8733 11.8281Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31039 12.4395C7.11819 12.281 7.11819 11.9866 7.31039 11.8281L10.4526 9.23642C10.7111 9.02321 11.1011 9.20709 11.1011 9.54216L11.1011 14.7254C11.1011 15.0605 10.7111 15.2444 10.4526 15.0312L7.31039 12.4395Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6221 5.00001L19.6221 19.2676",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6221 19.2676L22 19.2676",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6221 5L22 5",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56189 19.2676L4.56189 5",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56189 5L2.18396 5",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56189 19.2676L2.18396 19.2676",
    stroke: "white",
    strokeWidth: 1.8356,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginH);
export default __webpack_public_path__ + "static/media/marginH.e92e759581308cf38462cf1b9427ed74.svg";
export { ForwardRef as ReactComponent };